import React, { useEffect, useState, useRef } from 'react';


const AdminCategoryItem = ({ cate }) => {

}
export default AdminCategoryItem;